import React from 'react'
import { compose } from '@cbgms/base/utils/compose'
import { Route, Switch, withRouter } from 'react-router-dom'

import ProtectedRoute from 'core/routing/ProtectedRoute'
import withAuthenticated from 'core/routing/AuthenticationProvider'

import ProtectedRoutes from 'routes/ProtectedRoutes'
import AuthRoutes from 'routes/auth/Routes'
import { activationPage, homeRoute } from './routeNames'
import NoSession from '../app-support/auth/components/NoSession'
import Home from 'app-support/auth/views/Home'
import ActivationForm from '../app-support/auth/views/ActivationFrom'
import RedirectPreserver from './RedirectPreserver'
import RegionHandler from 'core/routing/RegionHandler'

interface IRoutesProps {
  authenticated: boolean
}

const enhance = compose<IRoutesProps, {}>(withRouter, withAuthenticated)

class Routes extends React.Component<IRoutesProps> {
  render() {
    const { authenticated } = this.props

    return (
      <>
        <RegionHandler />
        <Switch>
          <Route path={activationPage} component={ActivationForm} />
          <Route path='/auth' component={AuthRoutes} />

          {!authenticated ? (
            <Route
              path='/'
              exact
              render={() => (
                <RedirectPreserver>
                  <Home />
                </RedirectPreserver>
              )}
            />
          ) : (
            <ProtectedRoute path={homeRoute} component={ProtectedRoutes} />
          )}

          {/* Fallback */}
          <Route
            render={() => (
              <RedirectPreserver>
                <NoSession />
              </RedirectPreserver>
            )}
          />
        </Switch>
      </>
    )
  }
}

export default enhance(Routes)
